import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-scanned-assets-card',
  templateUrl: './scanned-assets-card.component.html',
  styleUrls: ['./scanned-assets-card.component.scss'],
})
export class ScannedAssetsCardComponent {
  @Input() set scannedAssets(val: any[]) {
    this.assetsList = val;
  }
  @Input() set openedUrl(val: string) {
    this.rtspUrl = val;
  }
  @Input() set isShowAsset(val: boolean) {
    this.isShowAssetDetails = val;
  }

  @Output() showDetails = new EventEmitter<any>();
  rtspUrl = '';
  isShowAssetDetails = false;
  assetsList: any[] = [];
  onShowDetails(val: any) {
    this.showDetails.emit(val);
  }
}
